var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto full-screen-shadow",class:[_vm.skinClasses],attrs:{"id":"app"}},[(_vm.layout === 'layout-full')?_c('ThisHeader'):_vm._e(),_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('br'),(_vm.enableScrollToTop)?_c('scroll-to-top'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }